/**
 * Gallery: category filter and lightbox for a grid of photo cards.
 *
 * Build it in Elementor with classes gal > gal-bar [gal-filter, gal-count] + gal-grid > gal-card
 * (plus one cat-* class, e.g. cat-education) [image, gal-over [gal-meta [gal-cat, gal-title], gal-expand]].
 * This file fills gal-filter with "All" and one button per category (with counts), keeps gal-count
 * up to date, and opens a lightbox on click or Enter: previous / next, thumbnails, Escape to close,
 * arrow keys, focus returned to the card. With more than PAGE photos (in the chosen filter) only the
 * first PAGE show; the next batch appears when the visitor scrolls near the end, or from the
 * "Show more photos" button under the grid. Hidden photos are lazy images, so they are not downloaded
 * until they show. Nothing runs when a page has no .gal.
 *
 * @package Sitamaa_Sahayata_Foundation
 */

( function () {
	'use strict';

	var ARROW = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
	var PAGE = 12;
	var t = window.ssfText || { f: String };

	function esc( s ) {
		var d = document.createElement( 'div' );
		d.textContent = s;
		return d.innerHTML;
	}
	var CLOSE = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';

	function catOf( card ) {
		var m = card.className.match( /\bcat-([a-z0-9-]+)/ );
		return m ? m[ 1 ] : '';
	}

	function text( card, sel ) {
		var el = card.querySelector( sel );
		return el ? el.textContent.trim() : '';
	}

	function fullSrc( img ) {
		var best = img.currentSrc || img.src;
		var set = img.getAttribute( 'srcset' );
		if ( set ) {
			var widest = 0;
			set.split( ',' ).forEach( function ( part ) {
				var bits = part.trim().split( /\s+/ );
				var w = parseInt( bits[ 1 ], 10 ) || 0;
				if ( w > widest ) {
					widest = w;
					best = bits[ 0 ];
				}
			} );
		}
		return best;
	}

	/* One lightbox for the page. */
	var box;
	var state = { list: [], index: 0, opener: null };

	function buildBox() {
		box = document.createElement( 'div' );
		box.className = 'gal-lb';
		box.setAttribute( 'role', 'dialog' );
		box.setAttribute( 'aria-modal', 'true' );
		box.setAttribute( 'aria-label', 'Photo viewer' );
		box.hidden = true;
		box.innerHTML = '<button type="button" class="gal-lb-close" aria-label="Close">' + CLOSE + '</button>' +
			'<button type="button" class="gal-lb-prev" aria-label="Previous photo">' + ARROW + '</button>' +
			'<figure class="gal-lb-fig"><img alt=""><figcaption><span class="gal-lb-cat"></span><span class="gal-lb-title"></span><span class="gal-lb-n"></span></figcaption></figure>' +
			'<button type="button" class="gal-lb-next" aria-label="Next photo">' + ARROW + '</button>' +
			'<div class="gal-lb-thumbs"></div>';
		document.body.appendChild( box );

		box.querySelector( '.gal-lb-close' ).addEventListener( 'click', close );
		box.querySelector( '.gal-lb-fig img' ).removeAttribute( 'src' );
		box.querySelector( '.gal-lb-prev' ).addEventListener( 'click', function () {
			show( state.index - 1 );
		} );
		box.querySelector( '.gal-lb-next' ).addEventListener( 'click', function () {
			show( state.index + 1 );
		} );
		box.addEventListener( 'click', function ( e ) {
			if ( e.target === box ) {
				close();
			}
		} );
		document.addEventListener( 'keydown', function ( e ) {
			if ( box.hidden ) {
				return;
			}
			if ( 'Escape' === e.key ) {
				close();
			} else if ( 'ArrowRight' === e.key ) {
				show( state.index + 1 );
			} else if ( 'ArrowLeft' === e.key ) {
				show( state.index - 1 );
			} else if ( 'Tab' === e.key ) {
				// Keep focus inside the viewer.
				var f = box.querySelectorAll( 'button' );
				var first = f[ 0 ];
				var last = f[ f.length - 1 ];
				if ( e.shiftKey && document.activeElement === first ) {
					e.preventDefault();
					last.focus();
				} else if ( ! e.shiftKey && document.activeElement === last ) {
					e.preventDefault();
					first.focus();
				}
			}
		} );
	}

	function show( i ) {
		if ( ! box.classList.contains( 'is-open' ) ) {
			box.querySelector( '.gal-lb-fig img' ).removeAttribute( 'src' );
		}
		var n = state.list.length;
		state.index = ( i + n ) % n;
		var card = state.list[ state.index ];
		var img = card.querySelector( 'img' );
		var big = box.querySelector( '.gal-lb-fig img' );
		var next = fullSrc( img );
		if ( big.getAttribute( 'src' ) && big.getAttribute( 'src' ) !== next ) {
			big.classList.add( 'is-swapping' );
			setTimeout( function () {
				big.src = next;
				big.alt = img.alt || '';
				var done = function () {
					big.classList.remove( 'is-swapping' );
				};
				if ( big.complete ) {
					window.requestAnimationFrame( done );
				} else {
					big.onload = done;
				}
			}, 180 );
		} else {
			big.src = next;
			big.alt = img.alt || '';
		}
		box.querySelector( '.gal-lb-cat' ).textContent = text( card, '.gal-cat' );
		box.querySelector( '.gal-lb-title' ).textContent = text( card, '.gal-title' );
		box.querySelector( '.gal-lb-n' ).textContent = ( state.index + 1 ) + ' / ' + n;
		Array.prototype.forEach.call( box.querySelectorAll( '.gal-lb-thumb' ), function ( t, k ) {
			t.classList.toggle( 'is-active', k === state.index );
			t.setAttribute( 'aria-current', k === state.index ? 'true' : 'false' );
		} );
	}

	function open( list, index, opener ) {
		if ( ! box ) {
			buildBox();
		}
		state.list = list;
		state.opener = opener;
		var thumbs = box.querySelector( '.gal-lb-thumbs' );
		thumbs.innerHTML = '';
		list.forEach( function ( card, k ) {
			var b = document.createElement( 'button' );
			b.type = 'button';
			b.className = 'gal-lb-thumb';
			b.setAttribute( 'aria-label', 'Show ' + ( text( card, '.gal-title' ) || 'photo ' + ( k + 1 ) ) );
			var im = document.createElement( 'img' );
			im.src = card.querySelector( 'img' ).currentSrc || card.querySelector( 'img' ).src;
			im.alt = '';
			b.appendChild( im );
			b.addEventListener( 'click', function () {
				show( k );
			} );
			thumbs.appendChild( b );
		} );
		box.hidden = false;
		window.requestAnimationFrame( function () {
			box.classList.add( 'is-open' );
		} );
		document.documentElement.classList.add( 'gal-lb-open' );
		if ( window.ssfLenis ) {
			window.ssfLenis.stop();
		}
		show( index );
		box.querySelector( '.gal-lb-close' ).focus();
	}

	function close() {
		box.classList.remove( 'is-open' );
		setTimeout( function () {
			if ( ! box.classList.contains( 'is-open' ) ) {
				box.hidden = true;
			}
		}, 240 );
		document.documentElement.classList.remove( 'gal-lb-open' );
		if ( window.ssfLenis ) {
			window.ssfLenis.start();
		}
		if ( state.opener ) {
			state.opener.focus();
		}
	}

	function setup( root ) {
		var cards = Array.prototype.slice.call( root.querySelectorAll( '.gal-card' ) );
		if ( ! cards.length ) {
			return;
		}
		var filter = root.querySelector( '.gal-filter' );
		var count = root.querySelector( '.gal-count' );
		var current = 'all';
		var limit = PAGE;
		var moreBox = null;
		var busy = false;

		// Cards in the chosen filter, and the ones of those that are shown now.
		function matching() {
			return cards.filter( function ( c ) {
				return 'all' === current || catOf( c ) === current;
			} );
		}

		function keepSet() {
			return matching().slice( 0, limit );
		}

		function visible() {
			return cards.filter( function ( c ) {
				return ! c.hidden;
			} );
		}

		var REDUCE = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
		var timer;

		// Fade out the cards that leave, then swap, then fade the new set in one after another.
		function apply() {
			var keep = keepSet();
			var want = function ( c ) {
				return keep.indexOf( c ) !== -1;
			};
			clearTimeout( timer );
			if ( REDUCE ) {
				cards.forEach( function ( c ) {
					c.hidden = ! want( c );
				} );
				updateCount();
				updateMore();
				return;
			}
			var grid = root.querySelector( '.gal-grid' );
			visible().forEach( function ( c ) {
				c.classList.add( 'is-out' );
			} );
			timer = setTimeout( function () {
				var shown = [];
				// Hold the old height, swap the cards, then glide to the new height, so the content
				// below the gallery moves smoothly instead of jumping.
				var from = grid ? grid.offsetHeight : 0;
				cards.forEach( function ( c ) {
					c.hidden = ! want( c );
					if ( ! c.hidden ) {
						c.classList.add( 'is-out' );
						shown.push( c );
					}
				} );
				if ( grid ) {
					grid.style.height = 'auto';
					var to = grid.offsetHeight;
					grid.style.overflow = 'hidden';
					grid.style.height = from + 'px';
					void grid.offsetHeight;
					grid.style.transition = 'height 420ms cubic-bezier(0.22, 1, 0.36, 1)';
					grid.style.height = to + 'px';
					setTimeout( function () {
						grid.style.transition = '';
						grid.style.height = '';
						grid.style.overflow = '';
					}, 440 );
				}
				updateCount();
				updateMore();
				window.requestAnimationFrame( function () {
					shown.forEach( function ( c, n ) {
						setTimeout( function () {
							c.classList.remove( 'is-out' );
						}, Math.min( n, 7 ) * 50 );
					} );
				} );
				if ( window.ScrollTrigger ) {
					window.ScrollTrigger.refresh();
				}
			}, 260 );
		}

		// Show the next batch: the cards already on screen stay, the new ones fade in one after another.
		function more() {
			if ( busy ) {
				return;
			}
			var from = limit;
			limit += PAGE;
			var add = matching().slice( from, limit );
			if ( ! add.length ) {
				updateMore();
				return;
			}
			busy = true;
			add.forEach( function ( c ) {
				c.hidden = false;
				if ( ! REDUCE ) {
					c.classList.add( 'is-out' );
				}
			} );
			updateCount();
			updateMore();
			window.requestAnimationFrame( function () {
				add.forEach( function ( c, n ) {
					setTimeout( function () {
						c.classList.remove( 'is-out' );
					}, REDUCE ? 0 : Math.min( n, 7 ) * 50 );
				} );
			} );
			if ( window.ScrollTrigger ) {
				window.ScrollTrigger.refresh();
			}
			setTimeout( function () {
				busy = false;
			}, 500 );
		}

		function updateMore() {
			var left = matching().length - limit;
			if ( left <= 0 ) {
				if ( moreBox ) {
					moreBox.hidden = true;
				}
				return;
			}
			if ( ! moreBox ) {
				moreBox = document.createElement( 'div' );
				moreBox.className = 'gal-more';
				moreBox.innerHTML = '<button type="button" class="gal-more-btn"></button>';
				moreBox.querySelector( 'button' ).addEventListener( 'click', more );
				root.appendChild( moreBox );
				// Load the next batch on its own when the end of the grid comes near.
				if ( 'IntersectionObserver' in window ) {
					new window.IntersectionObserver( function ( entries ) {
						if ( entries[ 0 ].isIntersecting && ! moreBox.hidden ) {
							more();
						}
					}, { rootMargin: '0px 0px 300px 0px' } ).observe( moreBox );
				}
			}
			moreBox.hidden = false;
			moreBox.querySelector( 'button' ).textContent = t.f( t.gal_more, left );
		}

		function updateCount() {
			if ( count ) {
				var v = visible().length;
				count.textContent = 1 === v && 1 === cards.length ? t.gal_count_1 : ( v === cards.length ? t.f( t.gal_count_all, v ) : t.f( t.gal_count, v, cards.length ) );
			}
		}

		if ( filter ) {
			var cats = [];
			var labels = {};
			cards.forEach( function ( c ) {
				var k = catOf( c );
				if ( k && cats.indexOf( k ) === -1 ) {
					cats.push( k );
					labels[ k ] = text( c, '.gal-cat' ) || k;
				}
			} );
			filter.setAttribute( 'role', 'group' );
			filter.setAttribute( 'aria-label', 'Filter photos' );
			// inc/gallery.php prints the buttons in the HTML; build them here only if they are missing.
			var printed = filter.querySelectorAll( '.gal-chip[data-cat]' );
			var keys = printed.length ? Array.prototype.map.call( printed, function ( x ) {
				return x.dataset.cat;
			} ) : [ 'all' ].concat( cats );
			if ( ! printed.length ) {
				filter.innerHTML = '';
			}
			keys.forEach( function ( k, i ) {
				var b = printed[ i ];
				if ( ! b ) {
					b = document.createElement( 'button' );
					b.type = 'button';
					b.className = 'gal-chip';
					b.dataset.cat = k;
					var n = 'all' === k ? cards.length : cards.filter( function ( c ) {
						return catOf( c ) === k;
					} ).length;
					b.innerHTML = esc( 'all' === k ? t.gal_all : labels[ k ] ) + ' <span class="gal-chip-n">' + n + '</span>';
					b.setAttribute( 'aria-pressed', 'all' === k ? 'true' : 'false' );
				}
				b.addEventListener( 'click', function () {
					if ( current === k ) {
						return;
					}
					current = k;
					limit = PAGE;
					Array.prototype.forEach.call( filter.children, function ( x ) {
						x.setAttribute( 'aria-pressed', x === b ? 'true' : 'false' );
					} );
					apply();
				} );
				if ( ! b.parentNode ) {
					filter.appendChild( b );
				}
			} );
		}

		cards.forEach( function ( c ) {
			c.setAttribute( 'tabindex', '0' );
			c.setAttribute( 'role', 'button' );
			c.setAttribute( 'aria-label', 'Open photo: ' + ( text( c, '.gal-title' ) || 'photo' ) );
			function go() {
				var list = visible();
				open( list, list.indexOf( c ), c );
			}
			c.addEventListener( 'click', go );
			c.addEventListener( 'keydown', function ( e ) {
				if ( 'Enter' === e.key || ' ' === e.key ) {
					e.preventDefault();
					go();
				}
			} );
		} );

		// First batch only, without animation.
		var first = keepSet();
		cards.forEach( function ( c ) {
			c.hidden = first.indexOf( c ) === -1;
		} );
		updateCount();
		updateMore();
	}

	function init() {
		if ( document.body.classList.contains( 'elementor-editor-active' ) ) {
			return;
		}
		Array.prototype.forEach.call( document.querySelectorAll( '.gal' ), setup );
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
}() );
